import layout from '@/components/common/layout';
import lchapterList from '../views/lchapter/list';
import lchapterCreate from "../views/lchapter/create";

export default [
    {
        path: '/lchapter',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "课程列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lchapterList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增课程",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lchapterCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑课程",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lchapterCreate,
            },
        ]
    },
];
